import type { UserBadgeVariant } from "./types";

export const BADGE_VARIANT_CLASSES: Record<
  UserBadgeVariant,
  { badge: string; hover: string; addButton: string }
> = {
  blue: {
    badge: "bg-info-subtle-strong text-info-text",
    hover: "hover:text-info-text",
    addButton: "bg-surface-sunken text-info-text hover:bg-info-subtle-strong",
  },
  green: {
    badge: "bg-success-subtle-strong text-success-text",
    hover: "hover:text-success-text",
    addButton: "bg-surface-sunken text-success-text hover:bg-success-subtle-strong",
  },
};
